/* eslint-disable */
export type StreamReceiverDataHandler<T = any> = (data: T) => void;
export type StreamReceiverErrorHandler = (error: any) => void;
export type StreamReceiverDoneHandler = () => void;

export class StreamReceiver {
  private baseURL: string;
  private receivedString: string;
  constructor() {
    this.baseURL = process.env.REACT_APP_BACKEND_URL || '';
    this.receivedString = '';
  }

  async post(
    endpoint: string,
    body: any,
    onDataReceive: StreamReceiverDataHandler,
    onErrorReceive?: StreamReceiverErrorHandler,
    onDone?: StreamReceiverDoneHandler,
  ) {
    try {
      const token = localStorage.getItem('token');

      const response = await fetch(this.baseURL + endpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          ...(token ? { Authorization: `Bearer ${token}` } : {}),
          'Cache-Control': 'no-cache',
          Pragma: 'no-cache',
          Expires: '0',
        },
        body: JSON.stringify(body),
      });

      if (response.status === 401) {
        localStorage.removeItem('token');
        window.location.reload();
        return;
      }

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      if (!response.body) {
        throw new Error('ReadableStream not supported in this browser.');
      }

      const reader = response.body.getReader();
      const decoder = new TextDecoder();

      while (true) {
        const { done, value } = await reader.read();
        if (done) break;

        const chunk = decoder.decode(value, { stream: true });
        this.receivedString += chunk;
        const parts = this.receivedString.split('\n');
        while (parts.length) {
          const part = parts.shift();
          let data: any;
          if (part) {
            try {
              data = JSON.parse(part);
              onDataReceive(data);
            } catch (err) {
              // console.error(err);
              parts.unshift(part);
              break;
            }
          }
        }
        this.receivedString = parts.join('\n');
      }

      onDone?.();
    } catch (error) {
      onErrorReceive?.(error);
    }
  }
}
